import Link from "@/utils/link";

import GetStartedCreate from "@/components/Logo/GetStartedCreate";
import GetStartedUpdate from "@/components/Logo/GetStartedUpdate";
import GetStartedUpgrade from "@/components/Logo/GetStartedUpgrade";

import { useAuth } from "@/lib/auth";
import { isSignedIn } from "@/components/user/UserUtils";

const CpGetStartedCards = () => {
    return (
        <div className="bg-gray-200">
            <div className="container mx-auto px-8 sm:px-16">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-16 py-16">
                    <Card
                        index="1"
                        title="Create or Claim Community"
                        Logo={GetStartedCreate}
                        href="/community-portal/my-communities"
                    ></Card>

                    <Card
                        index="2"
                        title="Update Community"
                        Logo={GetStartedUpdate}
                        href="/community-portal/my-communities"
                    ></Card>

                    <Card
                        index="3"
                        title="Upgrade Community"
                        Logo={GetStartedUpgrade}
                        href="/community-portal/my-communities"
                    ></Card>
                </div>
            </div>
        </div>
    );
};

const Card = ({ index, title, children, Logo, href = "/" }) => {
    const auth = useAuth();

    return (
        <Link href={href} disabled={!isSignedIn(auth)}>
            <a className="flex flex-col items-center text-center">
                <div className="relative">
                    {/*<div className="absolute top-4 -left-16 text-6xl text-gray-500">
                        {index}
                    </div>*/}
                    <Logo />
                </div>

                <h3 className="mt-8 h-24 text-primary-500 text-3xl font-headline font-bold uppercase">
                    {title}
                </h3>

                <p className="text-lg">{children}</p>
            </a>
        </Link>
    );
};

export default CpGetStartedCards;
